import CButton from "components/CButton";
import CDialog from "components/CDialog";
import CTextField from "components/CTextField";
import useDocumentUploadForm from "./useDocumentUploadForm";
import CDialogTransition from "components/CDialogTransition";
import { Box, MenuItem, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

type DialogProps = {
  open: boolean;
  handleClose: () => void;
  neededDocs: string[] | undefined;
  isBorrower: boolean;
};

const CDocUploadDocumentDialog: React.FC<DialogProps> = ({
  open,
  handleClose,
  neededDocs,
  isBorrower,
}) => {
  const theme = useTheme();
  const form = useDocumentUploadForm(handleClose, isBorrower);
  const [listDocs, setListDocs] = useState(neededDocs);

  useEffect(() => {
    setListDocs(neededDocs);
    form.setValue("docOption", listDocs ? listDocs[0] : "");
  }, [neededDocs, listDocs, form]);

  return (
    <CDialog
      maxWidth="md"
      title={"Upload Missing Documents"}
      open={open}
      onClose={handleClose}
      TransitionComponent={CDialogTransition}
      aria-labelledby="customized-dialog-title"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Typography mb={2} color={theme.palette.text.secondary} fontStyle={""}>
        Please upload your documents in PDF format
      </Typography>
      <form onSubmit={form.uploadDocument}>
        <CTextField
          select
          id="missingDocs"
          fullWidth
          defaultValue={listDocs ? listDocs[0] : ""}
          sx={{
            mb: 2,
            textAlign: "left",
          }}
          error={form.formState.errors.docOption?.message}
          label="Missing Docs"
          {...form.register("docOption", {
            required: {
              value: true,
              message: "Please select an option",
            },
          })}
        >
          {listDocs ? (
            listDocs.map((doc) => (
              <MenuItem key={doc} value={doc}>
                {doc}
              </MenuItem>
            ))
          ) : (
            <MenuItem value="">Select</MenuItem>
          )}
        </CTextField>
        <CTextField
          fullWidth
          sx={{
            pb: 2,
          }}
          error={form.formState.errors.document?.message}
          type={"file"}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            form.convertToBase64(e);
          }}
          inputProps={{
            accept: [".pdf"],
            ignore: ".svg",
          }}
        />
        {form.errorSubmit && (
          <Typography marginTop={2} color={theme.palette.error.main}>
            {form.errorSubmit}
          </Typography>
        )}
        <Box flexDirection={"row"} display={"flex"} mt={4}>
          <CButton
            type="reset"
            fullWidth
            variant="outlined"
            sx={{ mr: 2 }}
            disabled={form.loading}
            onClick={() => form.onReset()}
          >
            Discard
          </CButton>
          <CButton
            type="submit"
            fullWidth
            variant="contained"
            sx={{ ml: 2 }}
            loading={form.loading}
          >
            Save
          </CButton>
        </Box>
      </form>
    </CDialog>
  );
};

export default CDocUploadDocumentDialog;
